import type { OptionType } from '@omnipresentgroup/design-system';
import { LegalEntityType } from '@omnipresentgroup/types';

export const LEGAL_ENTITY_TYPE_PARAM = 'type';
export const LEGAL_ENTITY_STATUS_PARAM = 'status';

export const LEGAL_ENTITY_TYPE_LABELS: Map<LegalEntityType, string> = new Map([
  [LegalEntityType.EMPLOYER_OF_RECORD, 'Employer of record'],
  [LegalEntityType.CONSULTING_ENTITY, 'Consulting entity'],
  [LegalEntityType.VIRTUAL_EMPLOYER, 'Virtual employer'],
  [
    LegalEntityType.PROFESSIONAL_EMPLOYMENT_ORGANISATION,
    'Professional employment organisation',
  ],
  [LegalEntityType.PENDING, 'Pending'],
]);

export const LEGAL_ENTITY_TYPE_OPTIONS: OptionType[] = Object.values(
  LegalEntityType,
)
  .map((legalEntityType) => ({
    label:
      LEGAL_ENTITY_TYPE_LABELS.get(legalEntityType as LegalEntityType) ?? '-',
    value: legalEntityType,
  }))
  .sort((a, b) => a.label.localeCompare(b.label));

export const LEGAL_ENTITY_STATUS_OPTIONS: OptionType[] = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
].sort((a, b) => a.label.localeCompare(b.label));
